import { render, staticRenderFns } from "./NewEditCliente.vue?vue&type=template&id=341363cf"
import script from "./NewEditCliente.vue?vue&type=script&lang=js"
export * from "./NewEditCliente.vue?vue&type=script&lang=js"
import style0 from "./NewEditCliente.vue?vue&type=style&index=0&id=341363cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports